export const BriefCaseSmallIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    {...props}>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M8 22.5h8c4.02 0 4.74-1.61 4.95-3.57l.75-8c.27-2.44-.43-4.43-4.7-4.43H7c-4.27 0-4.97 1.99-4.7 4.43l.75 8c.21 1.96.93 3.57 4.95 3.57zM8 6.5v-.8c0-1.77 0-3.2 3.2-3.2h1.6C16 2.5 16 3.93 16 5.7v.8"></path>
    <path
      stroke="#455A64"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M14 13.5v1.02c0 1.09-.01 1.98-2 1.98-1.98 0-2-.88-2-1.97V13.5c0-1 0-1 1-1h2c1 0 1 0 1 1zM21.65 11.5A16.484 16.484 0 0114 14.52M2.62 11.77c2.25 1.54 4.79 2.47 7.38 2.76"></path>
  </svg>
);
